import { Component, inject, OnInit } from '@angular/core';
import { EmployeeService } from '@beautyapp/core';
import { CdkDragDrop, moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'beautyapp-appointment-resource-order',
    templateUrl: './appointment-resource-order.component.html',
    styleUrls: ['./appointment-resource-order.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DragDropModule,
        NzGridModule,
        NzButtonModule,
        NzIconModule,
        NzDividerModule,
        TranslateModule,
        TranslatePipe
    ]
})
export class AppointmentResourceOrderComponent {
  private drawerRef: NzDrawerRef<boolean> = inject(NzDrawerRef);
  private employeeService: EmployeeService = inject(EmployeeService);
  private router: Router = inject(Router);


  employees = toSignal(this.employeeService.getCalendar());



  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.employees(), event.previousIndex, event.currentIndex);
  }

  update() {
    this.employeeService.employeeOrdering(this.employees()).subscribe((res) => {
      this.drawerRef.close(true);
    });
  }

  openEmployeeCalendar(item: any) {
    this.drawerRef.close(true);
    this.router.navigate(['/calendars/day/forEmployee', item.userId]);
  }
}
